
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

type SubscriptionStatus = 'active' | 'cancelled' | 'paused' | 'payment_update_needed';

interface SubscriptionStatusBadgeProps {
  status: SubscriptionStatus | string;
}

export function SubscriptionStatusBadge({ status }: SubscriptionStatusBadgeProps) {
  const statusConfig = {
    active: {
      label: 'Активна',
      className: 'bg-green-100 text-green-800 hover:bg-green-200'
    },
    paused: {
      label: 'Приостановлена',
      className: 'bg-yellow-100 text-yellow-800 hover:bg-yellow-200'
    },
    cancelled: {
      label: 'Отменена',
      className: 'bg-red-100 text-red-800 hover:bg-red-200'
    },
    payment_update_needed: {
      label: 'Требуется карта',
      className: 'bg-blue-100 text-blue-800 hover:bg-blue-200'
    }
  };

  const normalizedStatus = (status || '').toLowerCase() as SubscriptionStatus;
  const config = statusConfig[normalizedStatus] || {
    label: normalizedStatus || 'Неизвестно',
    className: 'bg-gray-100 text-gray-800'
  };

  return (
    <Badge variant="outline" className={cn(config.className, 'font-normal')}>
      {config.label}
    </Badge>
  );
}
